export const USER_UPGRADE_CLEAR = "USER_UPGRADE_CLEAR";
const HYDRATE = "__NEXT_REDUX_WRAPPER_HYDRATE__";

export const types = {
  GET_OBD_BEGINS: "GET_OBD_BEGINS",
  GET_OBD_SUCCESS: "GET_OBD_SUCCESS",
  GET_OBD_FAILURE: "GET_OBD_FAILURE",
  GENERATE_PIN_BEGINS: "GENERATE_PIN_BEGINS",
  GENERATE_PIN_SUCCESS: "GENERATE_PIN_SUCCESS",
  GENERATE_PIN_FAILURE: "GENERATE_PIN_FAILURE",
  RESET_GENERATE_PIN: "RESET_GENERATE_PIN",
  VALIDATE_PIN_BEGINS: "VALIDATE_PIN_BEGINS",
  VALIDATE_PIN_SUCCESS: "VALIDATE_PIN_SUCCESS",
  VALIDATE_PIN_FAILURE: "VALIDATE_PIN_FAILURE",
  VALIDATE_PIN_RESET: "VALIDATE_PIN_RESET",
  RESET_GET_OBD: "RESET_GET_OBD",

  GET_OBD_COMPLETE_BEGINS: "GET_OBD_COMPLETE_BEGINS",
  GET_OBD_COMPLETE_SUCCESS: "GET_OBD_COMPLETE_SUCCESS",
  GET_OBD_COMPLETE_FAILURE: "GET_OBD_COMPLETE_FAILURE",

  SET_CONTACT_TO_VERIFY: "SET_CONTACT_TO_VERIFY",
  RESET_CONTACT_TO_VERIFY: "RESET_CONTACT_TO_VERIFY",
  SET_OBD_PARAMS: "SET_OBD_PARAMS",
  RESET_OBD_PARAMS: "RESET_OBD_PARAMS",

  CHECK_OBD_BEGINS: "CHECK_OBD_BEGINS",
  CHECK_OBD_SUCCESS: "CHECK_OBD_SUCCESS",
  CHECK_OBD_FAILURE: "CHECK_OBD_FAILURE",
  RESET_CHECK_OBD: "RESET_CHECK_OBD",

  SET_PUBLI_CHECK_STATUS: "SET_PUBLI_CHECK_STATUS",
  RESET_PUBLI_CHECK_STATUS: "RESET_PUBLI_CHECK_STATUS",

  REDIRECT: "REDIRECT",

  
};

export const initialState = {
  obd: null,
  obdFetching: false,
  obdFetched: false,
  obdError: false,
  obdGestionUrl: null,
  stateProductId: null,
  stateServiceType: null,

  obdComplete: null,
  obdCompleteFetching: false,
  obdCompleteFetched: false,
  obdCompleteError: false,

  pinGenerate: null,
  pinGenerateFetching: false,
  pinGenerateError: false,

  pinValidate: null,
  pinValidateFetching: false,
  pinValidateError: false,

  contactToVerify: null,

  obdChecked: null,
  obdCheckedFetching: false,
  obdCheckedError: false,
  obdCheckedFetched: false,
};

export const actions = {
  getObd: params => ({ type: types.GET_OBD_BEGINS, payload: params }),
  successGetObd: data => ({ type: types.GET_OBD_SUCCESS, payload: data }),
  failureGetObd: error => ({ type: types.GET_OBD_FAILURE, payload: error }),
  generatePin: params => ({ type: types.GENERATE_PIN_BEGINS, payload: params }),
  successGeneratePin: data => ({ type: types.GENERATE_PIN_SUCCESS, payload: data }),
  failureGeneratePin: error => ({ type: types.GENERATE_PIN_FAILURE, payload: error }),
  resetGeneratePin: () => ({ type: types.RESET_GENERATE_PIN }),
  validatePin: params => ({ type: types.VALIDATE_PIN_BEGINS, payload: params }),
  resetValidatePin: () => ({ type: types.VALIDATE_PIN_RESET }),
  successValidatePin: data => ({ type: types.VALIDATE_PIN_SUCCESS, payload: data }),
  failureValidatePin: error => ({ type: types.VALIDATE_PIN_FAILURE, payload: error }),
  resetGetObd: () => ({ type: types.RESET_GET_OBD }),

  getCompleteObd: params => ({ type: types.GET_OBD_COMPLETE_BEGINS, payload: params }),
  successGetCompleteObd: data => ({ type: types.GET_OBD_COMPLETE_SUCCESS, payload: data }),
  failureGetCompleteObd: error => ({ type: types.GET_OBD_COMPLETE_FAILURE, payload: error }),

  setContactToVerify: params => ({ type: types.SET_CONTACT_TO_VERIFY, payload: params }),
  resetContactToVerify: () => ({ type: types.RESET_CONTACT_TO_VERIFY }),
  setObdParams: params => ({ type: types.SET_OBD_PARAMS, payload: params }),
  resetObdParams: () => ({ type: types.RESET_OBD_PARAMS }),

  checkObd: () => ({ type: types.CHECK_OBD_BEGINS }),
  successCheckObd: params => ({ type: types.CHECK_OBD_SUCCESS, payload: params }),
  failureCheckObd: error => ({ type: types.CHECK_OBD_FAILURE, payload: error }),
  resetCheckObd: () => ({ type: types.RESET_CHECK_OBD }),
  
  redirect: data => ({ type: types.REDIRECT, payload: data  }),
}

function reducer(state = { ...initialState }, { type, payload }) {
  // const ManagerReducers = (state = initialState, action) => {
  switch (type) {
    case HYDRATE: {
      const { manager } = payload;
      return {
        ...state,
        ...manager,
      };
    }
    case USER_UPGRADE_CLEAR:
      return initialState;
    case types.GET_OBD_BEGINS:
      return {
        ...state,
        obd: null,
        obdFetching: true,
        obdFetched: false,
        obdError: false,
      };
    case types.GET_OBD_SUCCESS:
      return {
        ...state,
        obd: payload,
        obdFetching: false,
        obdFetched: true,
        obdError: false,
      };
    case types.GET_OBD_FAILURE:
      return {
        ...state,
        obd: null,
        obdFetching: false,
        obdFetched: true,
        obdError: payload,
      };
    case types.GENERATE_PIN_BEGINS:
      return {
        ...state,
        pinGenerate: null,
        pinGenerateFetching: true,
        pinGenerateError: false,
      };
    case types.GENERATE_PIN_SUCCESS:
      return {
        ...state,
        pinGenerate: true,
        pinGenerateFetching: false,
        pinGenerateError: false,
      };
    case types.GENERATE_PIN_FAILURE:
      return {
        ...state,
        pinGenerate: null,
        pinGenerateFetching: false,
        pinGenerateError: payload || true,
      };
    case types.RESET_GENERATE_PIN:
      return {
        ...state,
        pinGenerate: null,
        pinGenerateFetching: false,
        pinGenerateError: false,
      };
    case types.VALIDATE_PIN_BEGINS:
      return {
        ...state,
        pinValidate: null,
        pinValidateFetching: true,
        pinValidateError: false,
      };
    case types.VALIDATE_PIN_SUCCESS:
      return {
        ...state,
        pinValidate: payload,
        pinValidateFetching: false,
        pinValidateError: false,
        contactToVerify: null,
      };
    case types.VALIDATE_PIN_FAILURE:
      return {
        ...state,
        pinValidate: null,
        pinValidateFetching: false,
        pinValidateError: payload || true,
      };
    case types.VALIDATE_PIN_RESET:
      return {
        ...state,
        pinValidate: null,
        pinValidateFetching: false,
        pinValidateError: false,
      };
    case types.RESET_GET_OBD:
      return {
        ...state,
        obd: null,
        obdFetching: false,
        obdFetched: false,
        obdError: false,
      };
    case types.GET_OBD_COMPLETE_BEGINS:
      return {
        ...state,
        obdComplete: null,
        obdCompleteFetching: true,
        obdCompleteFetched: false,
        obdCompleteError: false,
      };
    case types.GET_OBD_COMPLETE_SUCCESS:
      return {
        ...state,
        obdComplete: payload,
        obdCompleteFetching: false,
        obdCompleteFetched: true,
        obdCompleteError: false,
      };
    case types.GET_OBD_COMPLETE_FAILURE:
      return {
        ...state,
        obdComplete: null,
        obdCompleteFetching: false,
        obdCompleteFetched: true,
        obdCompleteError: payload,
      };
    case types.SET_CONTACT_TO_VERIFY:
      return {
        ...state,
        contactToVerify: payload,
      };
    case types.RESET_CONTACT_TO_VERIFY:
      return {
        ...state,
        contactToVerify: null,
      };
    case types.SET_OBD_PARAMS: {
      const { gestionUrl, stateProductId, stateServiceType } = payload;
      return {
        ...state,
        obdGestionUrl: gestionUrl,
        obdstateProductId: stateProductId,
        obdstateServiceType: stateServiceType,
      };
    }
    case types.RESET_OBD_PARAMS:
      return {
        ...state,
        obdGestionUrl: null,
        obdstateProductId: null,
        obdstateServiceType: null,
      };
    case types.CHECK_OBD_BEGINS:
      return {
        ...state,
        obdChecked: null,
        obdCheckedFetching: true,
        obdCheckedError: false,
        obdCheckedFetched: false,
      };
    case types.CHECK_OBD_SUCCESS:
      return {
        ...state,
        obdChecked: payload,
        obdCheckedFetching: false,
        obdCheckedError: false,
        obdCheckedFetched: true,
      };
    case types.CHECK_OBD_FAILURE:
      return {
        ...state,
        obdChecked: null,
        obdCheckedFetching: false,
        obdCheckedError: payload,
        obdCheckedFetched: true,
      };
    case types.RESET_CHECK_OBD:
      return {
        ...state,
        obdChecked: null,
        obdCheckedFetching: false,
        obdCheckedError: false,
        obdCheckedFetched: false,
      };
    case types.REDIRECT:
      return {
        ...state,
      };
    default:
      return state;
  }
}

export default reducer;
